<template>
    <div class="shadow" v-if="isShow" @click="isShow = false">
        <div class="price-detail" @click.stop>
            <div class="price" v-show="!this.isHelp">
                <div class="item">
                    <div class="title">基本費用</div>
                    <div class="price">$ {{ cartTrial.base || 0 }}</div>
                </div>
                <div class="item">
                    <div class="title">商品代付費用</div>
                    <div class="price">$ {{ (cartProductPrice || 0) + (cartExpectedPrice || 0) }}</div>
                </div>
                <div class="item">
                    <div class="title">距離費用</div>
                    <div class="subtitle">共 {{ Math.round(cartTrial.location_distance / 10) / 100 }} 公里</div>
                    <div class="price">$ {{ cartTrial.distance || 0 }}</div>
                </div>
                <div class="item">
                    <div class="title">多點費用</div>
                    <div class="price">$ {{ cartTrial.multiple || 0 }}</div>
                </div>
                <div class="item">
                    <div class="title">急件費用</div>
                    <div class="price">$ {{ cartTrial.tip || 0 }}</div>
                </div>
                <div class="item">
                    <div class="title">折扣費用</div>
                    <div class="price">-$ {{ cartTrial.discount_max || 0 }}</div>
                </div>
                <div class="item" v-if="expectedFee">
                    <div class="title">服務費</div>
                    <div class="price">$ {{ expectedFee }}</div>
                </div>
                <div class="item">
                    <div class="title">等待費用</div>
                    <div class="content" v-if="cartTrial.wait">$ {{ cartTrial.wait || 0 }} 起</div>
                    <div class="content" v-else>另計</div>
                </div>
                <div class="item" v-show="cartTrial.night_surcharge">
                    <div class="title">夜間加成 22:00-08:00</div>
                    <div class="content">所有計價 x 1.5倍</div>
                </div>
            </div>
            <div class="help" v-show="this.isHelp">
                <div class="item">
                    <div class="title">基本里程計算</div>
                    <div class="subtitle">基本費用依照任務類別而定，1公里以上每公里加收 $25</div>
                    <div class="content">小數點四捨五入</div>
                </div>
                <div class="item">
                    <div class="title">等待時間計算</div>
                    <div class="subtitle">等待前10分鐘免費，10分鐘後每2分鐘加收 $10</div>
                </div>
                <div class="item">
                    <div class="title">多個任務點費用</div>
                    <div class="subtitle">兩個以上任務點，每增加一個任務點需加收 $25多點費用</div>
                    <div class="content">每一個任務點之距離及等待時間皆加總計算</div>
                </div>
                <div class="item">
                    <div class="title">服務費</div>
                    <div class="subtitle">代付服務會收取一筆服務費用</div>
                </div>
                <div class="item">
                    <div class="title">夜間加成</div>
                    <div class="subtitle">22:00 - 08:00 為加成時段，所有計價 x1.5倍</div>
                </div>
            </div>
            <div class="bottom">
                <div class="help-btn" @click.stop="isHelp = !isHelp">
                    <img :src="moreImg">
                    費用計算說明
                </div>
                <div class="total">
                    總計 $ {{ total }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'PriceDetail',
        data() {
            return {
                isShow: false,
                isHelp: false,
                type: null,
                feeRate: 0.003,
            }
        },
        computed: {
            total() {
                if (this.type === null) {
                    return this.cartPrice;
                }

                return Math.max(parseInt(this.cartPrice) + parseInt(this.cartProductPrice) + parseInt(this.cartExpectedPrice) + parseInt(this.expectedFee) - parseInt(this.discountSurplus), 0);
            },
            moreImg() {
                return this.isHelp ? require('@/assets/img/more-down.png') : require('@/assets/img/more-up.png');
            },
            expectedFee() {
                if (this.type === null) {
                    return 0;
                }
                return this.type === 'cash' ? 0 : Math.round(((this.cartExpectedPrice || 0) + this.cartProductPrice) * this.feeRate);
            },
            ...mapGetters(['cartTrial', 'cartPrice', 'cartExpectedPrice', 'cartProductPrice', 'discountSurplus'])
        },
        methods: {
            show(type = null, feeRate = 0.003) {
                this.type = type;
                this.isShow = true;
                this.feeRate = feeRate;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .shadow {
        z-index: 20;
        position: fixed;
        left: 0;
        top: 0;
        background-color: rgba(0,0,0,.40);
        width: 100%;
        height: 100%;
        max-width: 500px;
    }

    .price-detail {
        border-radius: 6px;
        background-color: rgba(255,255,255,1);
        box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
        padding: 10px 15px;
        position: absolute;
        bottom: 65px;
        right: 15px;
        left: 15px;
    }

    .price {
        .item {
            display: flex;
            justify-content: space-between;
            color: rgba(74,74,74,1);
            font-size: 13px;
            line-height: 18px;
            margin-top: 10px;

            .content {
                color: rgba(244,67,54,1);
                font-size: 13px;
                line-height: 18px;
            }

            .subtitle {
                color: rgba(155,155,155,1);
            }
        }
    }

    .bottom {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;

        .help-btn {
            color: rgba(74,144,226,1);
            display: flex;
            align-items: center;

            img {
                height: 20px;
                width: 20px;
                margin-right: 5px;
            }
        }

        .total {
            color: rgba(0,0,0,1);
            font-size: 16px;
            font-weight: 500;
            line-height: 22px;
        }
    }

    .help {
        text-align: left;

        .item {
            color: rgba(74,74,74,1);
            margin-top: 15px;

            .title {
                font-size: 16px;
                font-weight: 500;
                line-height: 22px;
            }

            .subtitle {
                font-size: 12px;
                line-height: 17px;
            }

            .content {
                color: rgba(155,155,155,1);
                font-size: 11px;
                line-height: 16px;
            }
        }
    }
</style>
